// plugins/currencyPlugin.js
import Vue from 'vue'
import axios from 'axios'

const CurrencyPlugin = {
  install(Vue) {
    const state = Vue.observable({
      exchangeRates: {},
      // currencies: [],
      baseCurrency: null,
      isLoaded: false,
    });

    const loadRates = async (base = 'USD') => {
      const cacheKey = `exchangeRatesCache_${base}`;
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        state.exchangeRates = parsed.rates;
        // state.currencies = parsed.currencies;
        state.baseCurrency = base;
        state.isLoaded = true;
        return;
      }

      try {
        const res = await axios.get('/api/assetflow/exchange_rates/getRates', {
            params: { base }
        });

        state.exchangeRates = res.data.rates;
        // state.currencies = res.data.currencies;
        state.baseCurrency = base;
        state.isLoaded = true;
        localStorage.setItem(cacheKey, JSON.stringify({
          rates: res.data.rates,
          // currencies: res.data.currencies,
          updated_at: new Date(),
        }));
      } catch (err) {
        console.error("Failed to load exchange rates", err);
      }
    };

    Vue.prototype.$currency = {
      state,
      async init(base = 'USD') {
        if (!state.isLoaded || state.baseCurrency !== base) {
          await loadRates(base);
        }
      },
      convert(amount, toCurrency) {
        if (!state.exchangeRates[toCurrency]) return amount;
        return amount * state.exchangeRates[toCurrency];
      },
    };
  }
};

Vue.use(CurrencyPlugin);
